module.exports = "/fonts/vendor/material-design-icons-icondist/MaterialIcons-Regular.woff2?2d8017489da689caedc1529e72055673";